import type { TFunction } from 'i18next';

import { ApiError } from '../api/client';

const LINKED_ENTITY_PATTERNS = [
    /foreign key/i,
    /violates.*constraint/i,
    /still referenced/i,
    /referenced by/i,
    /dependent/i,
    /still in use/i,
];

function extractErrorMessage(error: unknown): string {
    if (error instanceof ApiError) {
        return error.message;
    }
    if (error instanceof Error) {
        return error.message;
    }
    return '';
}

export function isLinkedEntityDeleteError(message: string): boolean {
    return LINKED_ENTITY_PATTERNS.some((pattern) => pattern.test(message));
}

export function formatDeleteErrorMessage(error: unknown, t: TFunction): string {
    const apiMessage = extractErrorMessage(error);

    if (!apiMessage) {
        return t('common.delete.unknownError');
    }

    if (isLinkedEntityDeleteError(apiMessage)) {
        return t('common.delete.linkedEntities', { detail: apiMessage });
    }

    return apiMessage;
}
